import { SET_SCROLL_TO_TOP } from 'state-management/constants/scroll';

export function setScrollToTop(shouldScrollToTop = true) {
    return {
        type: SET_SCROLL_TO_TOP,
        shouldScrollToTop,
    };
}
